import { Menu } from 'antd';
import { SubMenuProps } from 'antd/lib/menu/SubMenu';
import { useHasFeature } from 'client/components/schema/config/ClientConfigModule';
import { map, mapValues } from 'lodash';
import * as React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import {
  getIntlDefaultLanguage,
  IntlLanguageKey,
  IntlLanguages
} from './IntlLanguages';

export interface IIntlLanguageSelectorProps extends SubMenuProps {}

/**
 * Al momento supportiamo il multilingua solo su alcune pagine, per la
 * precisione:
 * - Home (elenco istanze)
 * - Elenco proprie istanze (richieste)
 * - Pagine di registrazione
 */
function hasLocationMultiLanguage(pathname: string) {
  return (
    pathname === '/' ||
    pathname === '/richieste' ||
    pathname.startsWith('/utente/')
  );
}

export function IntlLanguageSelector(props: IIntlLanguageSelectorProps) {
  const { ...otherProps } = props;

  // Ottiene informazioni sulla traducibilità
  const hasIntl = useHasFeature('intl');
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  const setLanguage = useCallback(
    async (languageKey: IntlLanguageKey) => {
      const language = IntlLanguages[languageKey];
      setLoading(true);
      i18n.changeLanguage(languageKey);
      setLoading(false);
    },
    [i18n]
  );

  const current = IntlLanguages[i18n.language as IntlLanguageKey];

  // Ottiene informazioni sulla pagina corrente
  const history = useHistory();
  const defaultLang = getIntlDefaultLanguage();

  useEffect(() => {
    // Quando cambia la pagina corrente, se non siamo su una pagina che
    // supporta il multilingua, dobbiamo ripristinare l'italiano
    const unlisten = history.listen(() => {
      if (
        !hasLocationMultiLanguage(history.location.pathname) &&
        !current.default
      ) {
        setLanguage(defaultLang.key as any);
      }
    });

    return () => {
      unlisten();
    };
  }, [history, current]);

  if (!hasIntl) return null;
  if (!hasLocationMultiLanguage(location.pathname)) return null;

  return (
    <Menu.SubMenu
      {...otherProps}
      title={current.label}
      style={{ float: 'right' }}
    >
      {map(IntlLanguages, (lang, key: IntlLanguageKey) => (
        <Menu.Item key={key} onClick={e => setLanguage(key)}>
          {lang.label} - {lang.name}
        </Menu.Item>
      ))}
    </Menu.SubMenu>
  );
}
